<template>
	<!-- 商品占用库存查询 -->
	<div class="InventoryUsage">
		<!-- 面包屑导航 -->
		<crumbs-bar @refresh="handleRefresh(true)" :crumbsList="['商品管理',$route.meta.title]">
			<!-- <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)">新增PC导航</el-button>
      </template> -->
		</crumbs-bar>
		<!-- 搜索框 -->
		<search-bar>
			<template>
				<el-input v-model="searchForm.orderid" style="width:180px;margin-right:5px" clearable
					placeholder="输入订单编号"></el-input>
				<el-input v-model="searchForm.name" style="width:180px;margin-right:5px" clearable placeholder="输入商品名称">
				</el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleRefresh(true)">搜索</el-button>
			</template>
		</search-bar>
		<!-- 数据展示 -->
		<el-table :data="tableData" stripe border height="calc(100% - 130px)" :row-style="{color:'#303133'}"
			tooltip-effect="dark" @selection-change="selectionChange" style="width: 100%" row-key="id">
			<el-table-column label="序号" align="center" type="index">
			</el-table-column>
			<el-table-column prop="GoodsName" align="center" show-overflow-tooltip label="商品名称">
			</el-table-column>
			<el-table-column prop="GoodsCode" align="center" show-overflow-tooltip label="商品编号">
			</el-table-column>
			<el-table-column prop="DrugSpec" align="center" show-overflow-tooltip label="商品规格">
			</el-table-column>
			<el-table-column prop="DrugFactory" align="center" show-overflow-tooltip label="生产厂家">
			</el-table-column>
			<el-table-column prop="OrderNo" align="center" show-overflow-tooltip label="订单编号">
			</el-table-column>
			<el-table-column prop="Lastmodifytime" align="center" show-overflow-tooltip label="订单日期">
			</el-table-column>
			<el-table-column prop="Quantity" label="占用库存" align="center" show-overflow-tooltip>
			</el-table-column>

		</el-table>
		<!-- 分页 -->
		<pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
			@hanCurrChange="hanCurrChange"></pagination>
	</div>
</template>

<script>
	//表单验证
	import {
		mustFill
	} from "@/mixins/data/valid.js"

	export default {
		name: 'InventoryUsage',
		data() {
			return {
				/**表格数据 */
				tableData: [],
				/**分页数据 */
				currPage: 1,
				pageSize: 20,
				allPage: 0,
				/**select选中项 */
				selectedList: [],
				// 搜索项
				searchForm: {
					name: '',
					orderid: ''
				},
				/**新增drawer */
				addDrawer: false,
				/**新增分类表单 */
				addForm: {
					id: '',
					reply: '',
				},
				addFormRule: {
					reply: [mustFill]
				},
			}
		},
		mounted() {
			this.getTableData()
		},
		methods: {
			updata() {
				this.getTableData()
			},
			/**获取表格 */
			getTableData(isSearch) {
				console.log(isSearch)
				// if (!this.searchForm.orderid && !this.searchForm.name) {
				// 	if (isSearch) {
				// 		this.$message({
				// 			message: '请输入搜索条件',
				// 			type: 'warning'
				// 		})
				// 	}
				// 	return
				// }
				let data = {
					orderNo: this.searchForm.orderid,
					goodsName: this.searchForm.name,
					pageIndex: this.currPage,
					pageSize: this.pageSize,
				}
				// let proc = "Proc_Admin_Statistical" // 存储过程名
				// let type = "ReturnList"
				this.$request({
					// url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(
					// 	data)) + "&proc=" + proc,
					url: "Management/GoodsAdmin/GetInventoryCarryingApi",//?type=" + type + "&proc=" + proc,
					method: "post",
					data: data
				}).then((res) => {
					this.tableData = []
					if (res.success == true) {
						this.tableData = (res.dataList || []).map(item => ({
							OrderNo: item.OrderNo, // 订单号
							GoodsName: item.GoodsName, // 商品名称
							Quantity: item.Quantity, // 占用库存
							GoodsCode:item.GoodsCode,//商品编号
							DrugSpec:item.DrugSpec,//商品规格
							DrugFactory:item.DrugFactory,//生产厂家
							Lastmodifytime:item.Lastmodifytime,//订单日期
						}))
						this.allPage = res.toTal
					}
				}).catch((err) => {
					window.console.log(err)
				})
			},
			/**刷新表格数据 */
			handleRefresh(isSearch) {
				this.currPage = 1;
				this.getTableData(isSearch)
			},
			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val
				this.getTableData()
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val
				this.getTableData()
			},
			/**客户 selection change触发事件 */
			selectionChange(section) {
				//存放选中的表格数据
				this.selectedList = section
			},

			/**关闭drawer 清空表单信息 */
			clearForm() {
				for (let key in this.addForm) {
					this.addForm[key] = ''
				}
				this.addDrawer = false
			},
		}
	}
</script>

<style scoped>
	.InventoryUsage {
		width: 100%;
		height: 100%;
	}
</style>
